export const ru = {
    'banners-language-geo-error':
        'Выбранный язык не соответсвует региону показа в одной из групп кампании',
    'default-error': 'Некорректно заполнены данные',
    'email-error': 'неправильный email',
    'invalid-domain-or-ssp': 'Неверно указана площадка/внешняя сеть: {subset}',
    'ip-from-private-network': 'Нельзя запрещать IP-адреса из частных подсетей',
    'ip-from-yandex-network':
        'IP-адреса из подсети Яндекса в список запрещенных вносить не нужно. Показы и клики с этих IP-адресов в статистике кампаний не учитываются',
    'metrika-counter-is-unavailable':
        'Вы выбрали счетчик метрики, который был удален и не может быть привязан к кампании',
    'metrika-error':
        'При сохранении кампании произошла ошибка, попробуйте еще раз',
    'name-cannot-be-null': 'Не указано название кампании',
    'name-enabled-symbols':
        'Название кампании должно содержать только буквы, цифры и знаки препинания',
    'name-max-length':
        'Название кампании не может быть длиннее {maxLength} символов',
    'unknown-ssp': 'Неизвестная площадка: {subset}',
    'vcard-city-letters': 'В названии города должны быть только буквы',
    'vcard-city-max-length':
        'Название города не может быть длиннее {maxLength} символов',
    'vcard-city-no-empty': 'Укажите город',
    'vcard-country-letters': 'В названии страны должна быть только буквы',
    'vcard-country-max-length':
        'Название страны не может быть длиннее {maxLength} символов',
    'vcard-country-no-empty': 'Укажите страну',
    'vcard-descr-format':
        'Описание должно содержать только буквы, цифры и знаки препинания',
    'vcard-descr-max-length':
        'Описание не может быть длиннее {maxLength} символов',
    'vcard-descr-no-empty': 'Введите описание',
    'vcard-error-text':
        'Произошла непредвиденная ошибка: {code}/{code}. Повторите попытку позже',
    'vcard-house-max-length':
        'Количество символов в номере дома не может быть больше {maxLength}',
    'vcard-house-no-empty': 'Укажите номер дома',
    'vcard-mail-format': 'Неверный формат email-адреса',
    'vcard-mail-max-length':
        'Адрес электронной почты не может быть длиннее {maxLength} символов',
    'vcard-mail-no-empty': 'Введите адрес электронной почты',
    'vcard-messenger-icq-format': 'Неверный формат логина ICQ',
    'vcard-messenger-jabber-format': 'Неверный формат логина JABBER',
    'vcard-messenger-login-length':
        'Логин не может быть длиннее {maxLength} символов',
    'vcard-messenger-mailruagent-format':
        'Неверный формат логина Агента Mail.Ru',
    'vcard-messenger-skype-or-msn-format': 'Неверный формат логина',
    'vcard-name-letters':
        'Название должно содержать только буквы, цифры или знаки препинания',
    'vcard-name-max-length':
        'Название не может быть длиннее {maxLength} символов',
    'vcard-name-no-empty': 'Укажите название компании',
    'vcard-office-format':
        'Для указания офиса используйте только буквы, цифры и знаки препинания',
    'vcard-office-max-length':
        'Количество символов в этом поле не может быть больше {maxLength}',
    'vcard-office-no-empty': 'Укажите офис',
    'vcard-ogrn-format': 'Неверный формат ОГРН/ОГРНИП',
    'vcard-ogrn-no-empty': 'Укажите ОГРН/ОГРНИП',
    'vcard-phone-city-code-format': 'Неправильный формат кода города',
    'vcard-phone-city-code-length':
        'Код города не может быть длиннее {maxLength} символов',
    'vcard-phone-city-code-no-empty': 'Укажите код города',
    'vcard-phone-country-code-format':
        'Код страны должен начинаться со знака «+» и содержать от 1 до 4 цифр. Допускается также код страны «8» в сочетании с кодом региона «800».',
    'vcard-phone-country-code-length':
        'Код страны не может быть длиннее {maxLength} символов',
    'vcard-phone-country-code-no-empty': 'Укажите код страны',
    'vcard-phone-country-code-start-no-plus':
        'В коде страны допустимы значения «8» или «0». В сочетании с кодом региона могут быть указаны значения «8 800», «8 804» и «0 800».',
    'vcard-phone-country-code-start-plus':
        'Укажите знак «+» перед кодом страны',
    'vcard-phone-extension-format': 'Неверный формат добавочного номера',
    'vcard-phone-extension-max-length':
        'Добавочный номер не может быть длиннее {maxLength} символов',
    'vcard-phone-number-format': 'Неверный формат номера телефона',
    'vcard-phone-number-max-length':
        'Номер телефона не может быть длиннее {maxLength} символов',
    'vcard-phone-number-min-length':
        'Номер телефона не может быть короче {minLength} символов',
    'vcard-phone-number-no-empty': 'Укажите номер телефона',
    'vcard-street-letters':
        'Название улицы должно содержать только буквы, цифры и знаки пунктуации',
    'vcard-street-max-length':
        'Название улицы не может быть длиннее {maxLength} символов',
    'vcard-street-no-empty': 'Введите улицу'
};
